export default __webpack_public_path__ + "static/media/728.4f0a5a50.gif";